import { Franchise } from '@/types';
import { isFeeFilled } from '@/utils/feeValue';
import { Typography } from 'antd';

interface Props {
  franchisor: Partial<Franchise>;
}

export default function FranchisorInvestmentProfile({ franchisor }: Props) {
  const renderCashRequired = () => {
    if (franchisor?.cashRequiredMin && franchisor?.cashRequiredMax) {
      return `$${franchisor?.cashRequiredMin}-$${franchisor?.cashRequiredMax}`;
    } else if (franchisor?.cashRequiredMin && !franchisor?.cashRequiredMax) {
      return `More than $${franchisor?.cashRequiredMin}`;
    } else if (!franchisor?.cashRequiredMin && franchisor?.cashRequiredMax) {
      return `Less than $${franchisor?.cashRequiredMax}`;
    }
    return '-';
  };

  return (
    <div className="details-section-column">
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Min Net Worth (USD)
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.minNetWorth ? franchisor.minNetWorth : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Cash Required (USD)
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {renderCashRequired()}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Franchise Fee
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.franchiseFee ? franchisor.franchiseFee : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">Royalty</Typography.Text>
        <Typography.Text className="general-info-value">
          {/* TCX-866: royalty is now { type, value, note }; unwrap .value
          for display. Rendering the type affix and note here is TCX-891.
          Empty means what isFeeFilled says, so whitespace shows '-'. */}
          {isFeeFilled(franchisor?.royalty) ? franchisor?.royalty?.value : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Avg Number of Staff
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.avgNumberOfStaff ? franchisor.avgNumberOfStaff : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">Ad Fee</Typography.Text>
        <Typography.Text className="general-info-value">
          {/* TCX-866: adFee is now { type, value, note }; unwrap .value
          for display. Rendering the type affix and note here is TCX-891.
          Empty means what isFeeFilled says, so whitespace shows '-'. */}
          {isFeeFilled(franchisor?.adFee) ? franchisor?.adFee?.value : '-'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Visa Candidates
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.visaCandidates ? 'Yes' : 'No'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Semi-Absentee Model
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.semiAbsenteeModel ? 'Yes' : 'No'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">B2B</Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.b2b ? 'Yes' : 'No'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Home Based
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.homeBased ? 'Yes' : 'No'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Master Franchise Opportunities
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.masterFranchiseOpportunities ? 'Yes' : 'No'}
        </Typography.Text>
      </div>
      <div className={'details-section-line'}>
        <Typography.Text className="general-info-text">
          Veteran Discount
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.veteranDiscount ? 'Yes' : 'No'}
        </Typography.Text>
      </div>
      <div className={'details-section-column'}>
        <Typography.Text className="general-info-text">
          Special Discount Programs
        </Typography.Text>
        <Typography.Text className="general-info-value">
          {franchisor?.specialDiscountPrograms
            ? franchisor.specialDiscountPrograms
            : '-'}
        </Typography.Text>
      </div>
    </div>
  );
}
